import React from "react";
import Card from "../Card";

function IndividualsTab() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1.4fr) minmax(0, 1fr)",
        gap: "1.75rem",
      }}
    >
      <div style={{ fontSize: 14, color: "#475569" }}>
        <p>
          We act as your long-term thinking partner, running every engagement
          through our disciplined 5-part planning framework. Our work spans
          investment strategy, life events, and coordinating with your tax and
          legal advisors.
        </p>
        <h4
          style={{
            margin: "0.75rem 0 0.5rem 0",
            fontSize: 15,
            fontWeight: 600,
          }}
        >
          How we help:
        </h4>
        <ul style={{ paddingLeft: "1.1rem" }}>
          <li>Portfolio construction and asset allocation</li>
          <li>Tax-aware investment decisions</li>
          <li>Retirement and income planning</li>
          <li>Real estate and second-home planning</li>
          <li>Education and multi-generational planning</li>
        </ul>
      </div>
      <Card
        title="Who this is for"
        body="Executives, professionals, and families with $1M+ in investable assets who want a calm, methodical approach—not noise or hype."
      />
    </div>
  );
}

export default IndividualsTab;
